<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules" :disabled="disabled">
      <el-row :gutter="20">
        <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 12}">
          <el-form-item label="温度计编号" prop="thermometerNo">
            <el-input
              clearable
              v-model="formData.thermometerNo"
              :placeholder="paramValueDisabled?'系统自动生成':'请输入温度计编号'"
              :disabled="paramValueDisabled || editType"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 12}">
          <el-form-item label="温度计品牌" prop="brandName">
            <dict-select
              filterable
              clearable
              v-model="formData.brandName"
              placeholder="请选择温度计品牌"
              default
              :body="brandNameDictParams"
              :selectedLabel.sync="formData.brandTypeName"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 12}">
          <el-form-item label="温度区间" prop="tempRange">
            <dict-select
              filterable
              clearable
              v-model="formData.tempRange"
              placeholder="请选择温度区间"
              default
              :body="selectTempRange"
              :selectedLabel.sync="formData.tempRangeName"
            />
          </el-form-item>
        </el-col>

        <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 12}">
          <el-form-item
            label="校准有效期"
            prop="calibrationValidity"
            size="small"
          >
            <el-date-picker
              style="width:100%"
              v-model="formData.calibrationValidity"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择校准有效期"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 8}">
          <el-form-item label="状态" prop="thermometerStatus">
            <el-radio-group v-model="formData.thermometerStatus">
              <el-radio label="Y">有效</el-radio>
              <el-radio label="N">无效</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      title="提示信息"
      :visible.sync="backDialogVisible"
      v-el-dialog-drag
      width="30%"
    >
      <span>是否要保存更改</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small"
          >取消</el-button
        >
        <el-button @click="close()" size="small">不保存</el-button>
        <el-button @click="save()" type="primary" size="small">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    disabled: Boolean,
    thermometerCode: String,
    editType: Boolean,
    isAddPage: Boolean,
  },
  data() {
    return {
      brandNameDictParams: {type: 'brandName'},
      paramValueDisabled: false,
      selectTempRange: {type: 'tempRange'},
      backDialogVisible: false,
      formData: {thermometerStatus: 'Y'},
      paramValue: '',
      rules: {
        thermometerNo: [
          {
            required: true,
            message: '请输入温度计编号',
            trigger: 'blur',
          },
        ],
        thermometerStatus: [
          {
            required: true,
            message: '请选择启用状态',
            trigger: 'change',
          },
        ],
      },
    }
  },
  activated() {
    this.getData()
  },
  mounted() {
    this.getData()
    this.runAutoThermometer()
  },
  methods: {
    //返回温度计auThermometerNo值
    runAutoThermometer() {
      this.$api.getSysParameterByIdApi({paramID: 'autoThermometer'}).then((res) => {
        this.paramValue = res.body.paramValue
        if (this.paramValue === 'Y') {
          this.paramValueDisabled = this.paramValue == 'Y'
        }
        if (this.paramValueDisabled && this.isAddPage){
          this.rules.thermometerNo.shift()
        }
      })
    },
    getData() {
      if (!this.thermometerCode) return
      this.$api
        .masterThermometerDetailApi({
          thermometerCode: this.thermometerCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      // if (this.paramValue == 'N') {
      //   if (
      //     this.formData.thermometerNo == null ||
      //     this.formData.thermometerNo == ''
      //   ) {
      //     this.$message({
      //       showClose: true,
      //       message: '温度编号不能为空',
      //       type: 'error',
      //     })
      //     return
      //   }
      // }
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      let loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$api
        .masterThermometerSaveApi(this.formData)
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
